import { render, staticRenderFns } from "./HistorySingo2.vue?vue&type=template&id=df334d7c&scoped=true&"
import script from "./HistorySingo2.vue?vue&type=script&lang=js&"
export * from "./HistorySingo2.vue?vue&type=script&lang=js&"
import style0 from "./HistorySingo2.vue?vue&type=style&index=0&id=df334d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df334d7c",
  null
  
)

export default component.exports